import { Produit } from '../../habilitation/models/produit.model';

export class SyntheseVolumesIGP {
    static jsonMap = {
        codeProduit: 'codeProduit',
        surface: 'surface',
        resteARevendiquer: 'resteARevendiquer',
        varRevendiqueChangementsDeno: 'varRevendiqueChangementsDeno',
        varRevendiqueDeclassement: 'varRevendiqueDeclassement',
        volConditionnements: 'volConditionnements',
        volIssusDr: 'volIssusDr',
        volRevendiques: 'volRevendiques',
        volTransactions: 'volTransactions'
    };

    codeProduit: string = undefined;

    produit: Produit;

    surface = 0;
    resteARevendiquer = 0;
    varRevendiqueChangementsDeno = 0;
    varRevendiqueDeclassement = 0;
    volConditionnements = 0;
    volIssusDr = 0;
    volRevendiques = 0;
    volTransactions = 0;
}
